// extracted by mini-css-extract-plugin
module.exports = {"singleDatepicker":"CB7OI","datepickerSplitter":"iZML+"};